/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import SVG from 'react-inlinesvg';
import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';

import { ButtonMenuStyled } from './styles';

function ButtonMenu({ label, icon, path, selected, id }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(path, { replace: true });
  };

  return (
    <ButtonMenuStyled selected={selected}>
      <div onClick={handleClick}>
        <SVG className="svg" src={icon} width={24} />
        <span>{label}</span>
      </div>
    </ButtonMenuStyled>
  );
}

export default ButtonMenu;

ButtonMenu.defaultProps = {
  selected: false,
};

ButtonMenu.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  selected: PropTypes.bool,
};
